import React from 'react';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BellIcon from '@mui/icons-material/AddAlert';
import BookIcon from '@mui/icons-material/Book';
import PortraitIcon from '@mui/icons-material/Portrait';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MailIcon from '@mui/icons-material/Mail';
import DoneIcon from '@mui/icons-material/Done';
import AlertIcon from '@mui/icons-material/NotInterested';
import DownloadIcon from '@mui/icons-material/GetApp';
import PendingIcon from '@mui/icons-material/Pending';


interface Props {
    text:string,
    second?:string,
    icon?:string,
    size?:number,
}

const Title:React.FC<Props> = (props)=> {
    let fontsize = {fontSize:"170%",display:'flex',alignItems:'center'};
    let iconsize = {marginRight:"0.25em",fontSize:"120%"};
    if( props.size ){
        if( props.size===2 ){
            fontsize = {fontSize:"150%",display:'flex',alignItems:'center'};
            iconsize = {marginRight:"0.25em",fontSize:"106%"};
        }
        if( props.size===3 ){
            fontsize = {fontSize:"120%",display:'flex',alignItems:'center'};
            iconsize = {marginRight:"0.25em",fontSize:"85%"};
        }
    }
	return (
        <div className="paperTitle">
            <div style={fontsize}>
                {props.icon==="store" &&
                <StoreIcon style={iconsize}/>
                }
                {props.icon==="cart" &&
                <ShoppingCartIcon style={iconsize}/>
                }
                {props.icon==="book" &&
                <BookIcon style={iconsize}/>
                }
                {props.icon==="bell" &&
                <BellIcon style={iconsize}/>
                }
                {props.icon==="trending" &&
                <TrendingUpIcon style={iconsize}/>
                }
                {props.icon==="portrait" &&
                <PortraitIcon style={iconsize}/>
                }
                {props.icon==="assignment" &&
                <AssignmentIcon style={iconsize}/>
                }
                {props.icon==="help" &&
                <HelpOutlineIcon style={iconsize}/>
                }
                {props.icon==="mail" &&
                <MailIcon style={iconsize}/>
                }
                {props.icon==="download" &&
                <DownloadIcon style={iconsize}/>
                }
                {props.icon==="closed" &&
                <AlertIcon style={iconsize}/>
                }
                {props.icon==="suspended" &&
                <PendingIcon style={iconsize}/>
                }
                {props.icon==="done" &&
                <DoneIcon style={iconsize}/>
                }
                {props.text}
                {props.second &&
                <span>{props.second}</span>
                }
            </div>
        </div>
    );
}

export default Title;
